import React, { useEffect } from 'react'
import { setNavigationBar, navigateRN } from '@docs/common'

import { Swiper } from 'antd-mobile'
import qs from 'qs'
// import { useTranslation } from '@volcengine/i18n'
import useTranslation from '../useNewTranslation'

import Banner1 from 'assets/images/bh3/archive_1.png'
import Banner2 from 'assets/images/bh3/archive_2.png'

import styles from './index.module.scss'
import useLanguageTrans from 'common/useLanguageTrans'

const Archive = () => {
  useLanguageTrans()
  const { t } = useTranslation()

  const handleArchive = () => {
    const { device_sn } = qs.parse(window.location.search.substr(1))
    console.log('handleArchive', device_sn)
    if (typeof device_sn === 'string') {
      navigateRN({
        plugin_id: 'ZX_T8030',
        device_sn,
        initial_routeName: 'HDBackup',
        initial_properties: {
          device_sn,
        },
      })
    }
  }

  useEffect(() => {
    setNavigationBar({
      title: t('h5_storage_edu_archive', { defaultValue: 'Video Archive' }),
    })
  })

  return (
    <>
      <Swiper
        indicator={(total: number, current: number) => (
          <div className={styles.Indicator}>
            {Array(total)
              .fill(null)
              .map((_, i) => (
                <i className={current === i ? styles.IndicatorActive : ''}></i>
              ))}
          </div>
        )}
      >
        <Swiper.Item>
          <div className={styles.Archive}>
            <img src={Banner1} alt="banner" />
            <p>
              {t('h5_storage_edu_archive_content1', {
                defaultValue:
                  'HomeBase 3 supports video backup through the USB port on the back. \nBy using a USB storage drive, it is possible to backup your event recordings.',
              })}
            </p>
          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className={styles.Archive}>
            <img src={Banner2} alt="banner" />
            <p>{t('h5_storage_edu_archive_tips1', { defaultValue: 'How to archive your video ' })}</p>
            <p>
              {t('h5_storage_edu_archive_tips2', {
                defaultValue: `Follow these steps to backup your event recordings from HomeBase 3: \n1. Insert a USB storage drive into the USB port of HomeBase 3. \n2. Go to HomeBase 3's section in the eufy Security app and then click on "Video Archive". \n3. Select the time range of the recordings you want to backup. \n4. Click "Archive" to start the backup and wait for the process to finish.`,
              })}
            </p>
          </div>
        </Swiper.Item>
      </Swiper>
      <div className={styles.Op}>
        <button onClick={handleArchive}>
          {t('h5_storage_edu_archive_button', { defaultValue: 'Archive My Video' })}
        </button>
      </div>
    </>
  )
}

export default Archive
